export const LooksLikeTestId = {
    LOOKS_LIKE_TITLE: 'looks-like-title',
    LOOKS_LIKE_SUBTITLE: 'looks-like-subTitle',
    LOOKS_LIKE_DESCRIPTION: 'looks-like-description',
    LOOKS_LIKE_LISTS: 'looks-like-lists',
    CONTINUE_BUTTON: 'continue-button',
    LOOKS_SKIP: 'looks-skip',
    CHECKBOX: 'checkbox',
    ACCOUNT_DIES: 'account-descriptions',
    ACCOUNT_TITLE: 'account-title'
};

export const AccountInfoTestId = {
    ACCOUNT_INFO_TITLE: 'account_titles',
    ACCOUNT_INFO_REQUIRED: 'account_required',
    ACCOUNT_INFO_LAST_NAME: 'cash_address_input',
    ACCOUNT_INFO_CITY: 'account_city',
    ACCOUNT_INFO_ADDRESS_LABEL: 'account_address_label',
    ACCOUNT_INFO_STATE: 'account_state_row',
    ACCOUNT_INFO_ADDITIONAL_INFO: 'account_additional_information',
    ACCOUNT_INFO_DRIVER_LICENSE: 'account_drivers_license',
    ACCOUNT_INFO_CHECKBOX: 'credit_enquiries_checkbox',
    ACCOUNT_INFO_PRIVACY_POLICY: 'privacy_policy_checkbox',
    ACCOUNT_INFO_COUNTRY: 'cash_account_info_country',
    ACCOUNT_INFO_ADDRESS_INPUT: 'cash_address_input',
    ACCOUNT_INFO_CITY_INPUT: 'cash_city_input',
    ACCOUNT_INFO_STATE_INPUT: 'cash_state',
    ACCOUNT_INFO_POSTAL_CODE_INPUT: 'cash_postal_code',
    ACCOUNT_INFO_LICENCE_NUMBER: 'driving_licence_number',
    ACCOUNT_INFO_LICENCE_STATE: 'driving_licence_state',
    ACCOUNT_INFO_ACCOUNT_CHECKBOX: 'account_checkbox',
    ACCOUNT_INFO_SMS_OPTIN_CHECKBOX: 'account_smsOptIn',
    CONTINUE_BUTTON: 'continue-button',
    LICENSE_MODAL: {
        BUTTON: 'license_model_button'
    }
};

export const PersonalInfoTestId = {
    PERSONAL_INFO_FIRST_NAME: 'gr_personal_info_first_name',
    PERSONAL_INFO_LAST_NAME: 'gr_personal_info_last_name',
    PERSONAL_INFO_DATE_OF_BIRTH: 'gr_personal_info_date_of_birth',
    PERSONAL_INFO_PHONE_NUMBER: 'gr_personal_info_phone_number',
    PERSONAL_INFO_PASSWORD: 'personal_info_password'
};

export const VerifyAddressValidationModalTestId = {
    ADDRESS_DESCRIPTION: 'gr_address_description'
};

export const VerificationTimeOutTestId = {
    MODAL_DESCRIPTION: 'modal-description',
    RESEND_BUTTON: 'resendButton'
};
export const ApplicationStatusTestId = {
    HEADER: 'header',
    SUB_TITLE: 'sub_title',
    CONTENT: 'content',
    BUTTON_LABEL: 'button_label'
};
